import React, { useState, useEffect } from 'react'
import { Box, Typography, Button, ListItem, Chip, CardContent, Grid, Card, IconButton, CircularProgress, List, Paper, useTheme, Backdrop } from '@material-ui/core'
import { baseApiUrl } from '../dataProvider/sails';
import Checkbox from '../checkbox'
import { makeStyles } from '@material-ui/core/styles'
import SelectBox from '../CustomizedUIs/CustomSelectBox'
import colors from '../CustomizedUIs/Colors'
import CustomPoper from '../CustomizedUIs/CustomPoper'
import DialogChooseFile from '../file-management/file-management-dialog'
import { useDataProvider, useTranslate, usePermissions, Loading } from 'react-admin'
import categories from '../categories'
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom'
import TextField from '../CustomizedUIs/CustomTextFiled'
import { isAudio, isImage, isVideo, isMedia } from '../utils';
import { red, pink } from '@material-ui/core/colors';
import ic_attachment from '../assets/icons/ic_attachment.png'
import ic_delete from '../assets/icons/primary-blue-bin.png'
import ic_computer from '../assets/icons/computer.png'
import ic_folder from '../assets/icons/folder-empty.png'
import CustomPopover from '../CustomizedUIs/CustomPopoverArrow'
import axios from 'axios'
import {
    usePopupState,
    bindToggle
} from 'material-ui-popup-state/hooks'
import CreateInSelect from '../CustomizedUIs/CreateInSelect';
import TextButton from '../CustomizedUIs/TextButton';


const bgColorError = pink['50'];
const textColorError = red['700'];

const useStyles = makeStyles(theme => ({

    borderImage: {
        borderRadius: '10px',
        backgroundColor: '#c1e5fa',
        '&:hover': {
            backgroundColor: '#a7cce7',
        }
    }
    , borderUpImange: {
        width: '500px',
        height: ' 145px',
        borderRadius: ' 10px',
        boxShadow: '0 5px 15px 0 rgba(0, 0, 0, 0.05)',
        backgroundColor: ' #ffffff',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    input: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        width: '100%',
        cursor: 'pointer',
        opacity: 0,
    },
    TitleImage: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    TextValue: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.385,
        letterSpacing: '0.13px',
        color: '#88898c',
    },

    large: {
        marginLeft: 16,
        border: '1px solid #ddd',
        background: 'white',
        borderRadius: 4,
        padding: 5,
        width: 150,
        height: 100,
        '&:hover': {
            boxShadow: '0 0 2px 1px rgba(0, 140, 186, 0.5)'
        }
    },
    title: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 500,
        lineHeight: '21.6px',
        letterSpacing: 'normal',
        color: '#4f5064',
        fontSize: '11px',
    },
}));

export function CircularProgressWithLabel(props) {
    return (
        <Box position="relative" display="inline-flex">
            <CircularProgress variant="static" size={80} {...props} />
            <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
            >
                <Typography variant="body1" component="div" style={{ color: 'white' }}>{`${Math.round(
                    props.value,
                )}%`}</Typography>
            </Box>
        </Box>
    );
}



const FormUpdate = ({ mediaId, loading, setLoading, setName }) => {
    const classes = useStyles()
    const dataProvider = useDataProvider()
    const { permissions, loaded } = usePermissions();
    const history = useHistory()
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openPoper, setOpenPopper] = React.useState(false);
    const [openType, setOpenType] = useState(false)
    const [types, setTypes] = useState()
    const [typeValue, setTypeValue] = useState('')
    const [fileType, setFileType] = useState('From file')
    const [openFileType, setOpenFileType] = useState(false)
    const [openCategory, setOpenCategory] = useState(false)
    const [messsageError, setMessageError] = useState('')
    const [file, setFile] = useState()
    const translate = useTranslate()
    const filePopupState = usePopupState({ variant: 'popper', popupId: 'pickFile' });
    const logoPopupState = usePopupState({ variant: 'popper', popupId: 'pickLogo' });
    const [saveLoading, setSaveLoading] = useState(false)
    const [progress, setProgress] = useState(0)
    const theme = useTheme()
    const [textValue, setTextValue] = useState({
        name: '',
        description: '',
        uri: '',
        actor: '',
        year: ''

    })
    const [error, setError] = useState({
        name: { status: mediaId ? false : true, messsage: '' },
        uri: { status: mediaId ? false : true, messsage: '' },
        description: { status: mediaId ? false : true, messsage: '' },
    })

    const [url, setUrl] = useState('')
    const [logo, setLogo] = useState()
    const [openFile, setOpenFile] = useState({
        status: false,
        defaultId: 1,
        format: '',
        setResponse: null
    })
    const [categories, setCategories] = useState([])
    const [isError, setIsError] = useState(mediaId ? false : true)
    const [newCategory, setNewCategory] = useState('')
    const [openCreate, setOpenCreate] = useState(false)

    const createCategory = (value) => {
        dataProvider('CREATE', "medias/createcategory", {
            data: {
                name: value
            }
        })
            .then(({ data }) => {
                var temps = [...categories]
                temps.unshift(data)
                setCategories(temps)
                setNewCategory('')
                setOpenCreate(false)
            })
            .catch(error => {
                setNewCategory('')
                console.error('Create:', error);
            })
    }

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const handleOpenFileDialog = (type) => {
        setOpenFile({
            status: true,
            defaultId: type === 'logo' ? 4 : 3,
            format: type === 'logo' ? isImage : isMedia,
            setResponse: type === 'logo' ? setLogo : setFile
        })
    }

    const handleClose = () => {
        setOpenFile({
            status: false,
            defaultId: 1,
            format: '',
            setResponse: null
        })
    }


    const handleOpenType = () => {
        setOpenType(!openType)
    }

    const handleOpenCategory = () => {
        setOpenCategory(!openCategory)
    }
    const onChangeCheckBox = (index) => {
        let temps = categories.slice()
        temps[index].checked = temps[index].checked !== undefined ? !temps[index].checked : true
        setCategories(temps)
    }


    const getCategory = () => {
        //setLoading(true);
        dataProvider('GET_LIST', "medias/findcategory", {
            filter: {
            },
            pagination: {
                page: 1,
                perPage: -1
            },
            sort: { field: 'name', order: 'ASC' },

        }).then(({ data }) => {
            setCategories(data)
        }).catch(error => {
            console.error('Get list error:', error);
        });
    }

    const getType = (type) => {
        //setLoading(true);
        dataProvider('GET_LIST', "medias/findtype", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        }).then(({ data }) => {
            if (data.length > 0)
                setTypeValue(type ? type : data[0])
            setTypes(data)
        }).catch(error => {
            console.error('Get list error:', error);
        });
    }

    const fileBrowserOnChange = event => {
        var files = [...event.target.files]
        var file = files[0]
        const newFile = {
            name: file.name,
            size: file.size,
            file: file,
            error: false,
            loading: false,
            override: false,
            type: file.type
        };
        setFile(newFile)
        filePopupState.close()
    }

    const fileBrowserOnChangeLogo = event => {
        var files = [...event.target.files]
        var file = files[0]
        const newFile = {
            name: file.name,
            size: file.size,
            file: file,
            error: false,
            loading: false,
            override: false,
            type: file.type
        };
        newFile.fd = URL.createObjectURL(file)
        setLogo(newFile)
        logoPopupState.close()
    }


    const getCategoryAssign = () => {
        dataProvider('GET_LIST', "medias/findcategorybymedia", {
            filter: {
                media: mediaId
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        }).then(({ data }) => {
            setCategories(data)
        }).catch(error => {
            console.error('Get list error:', error);
        });
    }

    const onChangTextValue = (event, name) => {

        setTextValue({
            ...textValue, [name]: event.target.value
        })
        if (name === 'name' || name === 'uri') {
            if (event.target.value === '')
                setError({
                    ...error, [name]: { status: true, messsage: 'required' }
                })
            else
                setError({
                    ...error, [name]: { status: false, messsage: '' }
                })
        }
        if (name === 'description') {
            if (event.target.value.length > 500) {
                setError({
                    ...error, [name]: { status: true, messsage: 'Input description < 500 characters' }
                })
            }
            else
                setError({
                    ...error, [name]: { status: false, messsage: '' }
                })
        }
    }

    const getMedia = () => {
        setLoading(true)
        dataProvider('GET_ONE', "medias", {
            id: mediaId

        }).then(({ data }) => {

            getType(data.type)
            setFileType(data.isVOD ? "VOD" : "From file")
            if (data.isVOD)
                setTextValue({
                    name: data.name,
                    description: data.description,
                    uri: data.file,
                    year: data.year,
                    actor: data.actor
                })
            else {
                setTextValue({
                    name: data.name,
                    description: data.description,
                    year: data.year,
                    actor: data.actor
                })
                setFile(data.file)
            }
            setLogo(data.image)
            setName(data.name)
            setLoading(false)
        })
    }


    const onCreate = () => {
        setSaveLoading(true)
        setProgress(0)
        const config = {
            onUploadProgress: function (progressEvent) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                setProgress(percentCompleted)
            },
            headers: { token: localStorage.getItem('token') }
        }
        const logoData = {
            name: logo.name,
            size: logo.size,
            type: logo.type,
        }
        if (logo.id) {
            logoData.id = logo.id
            logoData.fd = logo.fd
        }
        var fileData = fileType === 'VOD' ? textValue.uri : {
            name: file.name,
            size: file.size,
            type: file.type,
        }
        if (fileType !== 'VOD' && file.id) {
            fileData.fd = file.fd
            fileData.id = file.id
        }

        //setLoading(true)
        let data = new FormData()
        let body = {
            name: textValue.name,
            type: typeValue.id,
            isVOD: fileType === 'VOD',
            description: textValue.description,
            logo: logoData,
            file: fileData,
            actor: textValue.actor,
            categories: categories.filter(value => value.checked)
        }
        if (textValue.year !== '')
            body.year = textValue.year
        data.append('data', JSON.stringify(body))
        if (fileType !== 'VOD' && !file.id)
            data.append('file', file.file)
        if (!logo.id)
            data.append('file', logo.file)
        axios
            .post(`${baseApiUrl}/medias`, data, config)
            .then(response => {
                setTimeout(() => {
                    setSaveLoading(false)
                    history.push({
                        pathname: '/media',
                        state: { open: true, name: textValue.name, message: translate(`pos.categories.editFolder.success`) }
                    });
                }, 3000)
            })
            .catch(error => {
                setSaveLoading(false)
            })
    }

    const onEdit = () => {
        setSaveLoading(true)
        setProgress(0)
        const config = {
            onUploadProgress: function (progressEvent) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                setProgress(percentCompleted)
            },
            headers: { token: localStorage.getItem('token') }
        }
        var logoData = logo
        if (typeof (logo) !== 'string') {
            logoData = {
                name: logo.name,
                size: logo.size,
                type: logo.type,
            }
            if (logo.id) {
                logoData.id = logo.id
                logoData.fd = logo.fd
            }

        }

        var fileData = fileType === 'VOD' ? textValue.uri : {
            name: file.name,
            size: file.size,
            type: file.type,
        }
        if (fileType !== 'VOD' && file.id) {
            fileData.id = file.id
            fileData.fd = file.fd
        }

        //setLoading(true)
        let data = new FormData()
        let body = {
            name: textValue.name,
            type: typeValue.id,
            isVOD: fileType === 'VOD',
            description: textValue.description,
            logo: logoData,
            file: fileData,
            actor: textValue.actor,
            categories: categories.filter(value => value.checked)
        }
        if (textValue.year !== '')
            body.year = textValue.year
        data.append('data', JSON.stringify(body))
        if (textValue.year !== '')
            if (fileType !== 'VOD' && !file.id)
                data.append('file', file.file)
        if (!logo.id)
            data.append('file', logo.file)
        axios
            .put(`${baseApiUrl}/medias/${mediaId}`, data, config)
            .then(response => {
                setTimeout(() => {
                    setSaveLoading(false)
                    history.push({
                        pathname: '/media',
                        state: { open: true, name: textValue.name, message: translate(`pos.categories.editFolder.success`) }
                    });
                }, 3000)
            })
            .catch(error => {
                setSaveLoading(false)

            })
    }

    const pickTypeValue = (value) => {
        if (value !== typeValue) {
            setTypeValue(value)
            setUrl('')
        }
        setOpenType(false)
    }

    const pickFileTypeValue = (value) => {
        setFileType(value)
        setOpenFileType(false)
    }

    useEffect(() => {
        if (fileType !== 'VOD')
            setIsError(error.name.status || !file || !logo)
        else
            setIsError(error.name.status || error.uri.status || !logo)
    }, [error, logo, file, fileType])

    useEffect(() => {
        if (mediaId) {
            getCategoryAssign()
            getMedia()
        }
        else {
            getCategory()
            getType()
        }

    }, [])

    if (loading) return <Loading />
    if (!categories || !types) return null
    if (!loaded) return null

    return (
        <Box>
            <Backdrop style={{ zIndex: 1000 }} open={saveLoading} >
                <CircularProgressWithLabel value={progress} />
            </Backdrop>
            {
                messsageError != "" && (
                    <Box borderRadius='6px' my={1} width={500} bgcolor={bgColorError} py={1}>
                        <Typography variant='subtitle2' style={{ color: textColorError, margin: '1em' }}>{messsageError}</Typography>
                    </Box>
                )
            }
            <Box my={2}>
                <TextField
                    required
                    style={{ width: 500 }}
                    variant='filled'
                    label={translate(`pos.common.name`)}
                    error={error.name.status && error.name.messsage !== ''}
                    helperText={error.name.messsage}
                    onBlur={(event) => onChangTextValue(event, 'name')}
                    value={textValue.name}
                    onChange={(event) => onChangTextValue(event, 'name')}
                    endDom={<CustomPoper
                        open={openPoper}
                        anchorEl={anchorEl}
                        handleClick={handleClickOpenPoper}
                        handleClose={handleClosePoper}
                        title={translate(`pos.channels.channelNameTitle`)}
                        content={translate(`pos.channels.channelName`)}
                        icon={<b>?</b>}
                    />} />
            </Box>
            <Box my={2}>
                <SelectBox
                    label={translate(`pos.common.type`)}
                    value={<Typography className={classes.TextValue}>{typeValue.name}</Typography>}
                    open={openType}
                    handleClick={handleOpenType}
                    required={true}
                >
                    {
                        types.map(item => (
                            <ListItem key={'type' + item.id} className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickTypeValue(item)}>
                                <Typography className={classes.TextValue}>{item.name}</Typography>
                            </ListItem>
                        ))
                    }
                    {/* <ListItem className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickTypeValue('Movie')}>
                        <Typography className={classes.TextValue}>Movie</Typography>
                    </ListItem>
                    <ListItem className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickTypeValue('Instruction content')}>
                        <Typography className={classes.TextValue} >Instruction content</Typography>
                    </ListItem> */}

                </SelectBox>
            </Box>

            <Box my={2}>
                <TextField
                    style={{ width: 500 }}
                    variant='filled'
                    label={'Actor'}
                    value={textValue.actor}
                    onChange={(event) => onChangTextValue(event, 'actor')}
                    endDom={<CustomPoper
                        open={openPoper}
                        anchorEl={anchorEl}
                        handleClick={handleClickOpenPoper}
                        handleClose={handleClosePoper}
                        title={'actor'}
                        content={'This is actors in media'}
                        icon={<b>?</b>}
                    />} />
            </Box>

            <Box my={2}>
                <TextField
                    style={{ width: 500 }}
                    variant='filled'
                    label={'Release'}
                    type='number'
                    value={textValue.year}
                    onChange={(event) => onChangTextValue(event, 'year')}
                    endDom={<CustomPoper
                        open={openPoper}
                        anchorEl={anchorEl}
                        handleClick={handleClickOpenPoper}
                        handleClose={handleClosePoper}
                        title={'release'}
                        content={'This is the year of the release of the media'}
                        icon={<b>?</b>}
                    />} />
            </Box>


            <Box my={2}>
                <SelectBox
                    label={translate(`pos.channels.categories`)}
                    value={
                        !categories || categories.filter(element => element.checked).length === 0 ? '' :
                            <Box display='flex' width={420} overflow='hidden'>
                                {
                                    categories.filter((element) => element.checked).map((data, index) => {
                                        if (index < 5)
                                            return (
                                                <Chip
                                                    color='primary'
                                                    size='small'
                                                    style={{ marginRight: 8 }}
                                                    key={data.id}
                                                    label={data.name}
                                                />
                                            )
                                    }
                                    )

                                }
                                {
                                    categories.filter((element, index) => element.checked).length > 5 && <Typography variant='body1'>...</Typography>
                                }

                            </Box>

                    }
                    open={openCategory}
                    handleClick={handleOpenCategory}
                    CreateBox={
                        <CreateInSelect
                            name={'category'}
                            valueInput={newCategory}
                            onChangValueInput={(e) => { setNewCategory(e.target.value) }}
                            handelCreateNew={createCategory}
                            openCreate={openCreate}
                            handelCancelCreate={() => setOpenCreate(false)}
                            clickOpenCreate={() => setOpenCreate(!openCreate)}
                        />}
                >
                    {
                        categories.map((data, index) => (
                            <ListItem onClick={() => onChangeCheckBox(index)} key={data.key} style={{ padding: '8px' }} button className={classes.boxBoder}>
                                <Checkbox color='primary' checked={data.checked === undefined ? false : data.checked}></Checkbox>
                                <Typography className={classes.TextValue}>{data.name}</Typography>
                            </ListItem>
                        ))
                    }

                </SelectBox>
            </Box>


            <Box my={2}>
                <Card style={{ marginTop: "1em" }} className={classes.borderUpImange} >
                    <Grid container style={{ marginTop: "1em" }} item xs={12} sm={12} xl={12} lg={12} >
                        <Grid>
                            {
                                logo &&
                                <Box className={classes.large}>
                                    <img style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain'
                                    }} src={typeof (logo) === 'string' ? baseApiUrl + '/media/' + logo : (logo.id ? baseApiUrl + '/media/' + logo.fd : logo.fd)} />
                                </Box>

                            }

                        </Grid>
                        <Grid>
                            <CardContent>
                                <Typography className={classes.TitleImage} gutterBottom>
                                    {`${translate(`pos.user.changeimage`)} *`}
                                </Typography>
                                <Box my={1}>
                                    <Button {...bindToggle(logoPopupState)} className={classes.borderImage} color='primary'>{translate(`pos.media.chooseImage`)}</Button>
                                </Box>
                                <CustomPopover
                                    popupState={logoPopupState}
                                    zIndex={2}
                                    placement='right-end'

                                >
                                    <Paper style={{ padding: theme.spacing(1) }}>
                                        <List>
                                            <ListItem>
                                                <Typography className={classes.typography} style={{ fontWeight: 500, fontFamily: 'UniviaPro-Medium', marginRight: theme.spacing(1) }}>
                                                    {translate(`pos.infochannel.fileFormat`)}
                                                </Typography>
                                            </ListItem>
                                            <ListItem button>
                                                <img src={ic_computer} width={19} height={19}></img>
                                                <Typography className={classes.typography} style={{ cursor: 'pointer', marginLeft: theme.spacing(1) }}>{translate(`pos.infochannel.computer`)}</Typography>
                                                <input type='file' accept="image/*" onChange={fileBrowserOnChangeLogo} className={classes.input} />
                                            </ListItem>
                                            <ListItem button onClick={() => {
                                                logoPopupState.close()
                                                handleOpenFileDialog('logo')
                                            }}>
                                                <img src={ic_folder} width={19} height={19}></img>
                                                <Typography className={classes.typography} style={{ marginLeft: theme.spacing(1) }}>{translate(`pos.infochannel.fileManager`)}</Typography>

                                            </ListItem>

                                            <Box display='flex' justifyContent='flex-end'>
                                                <Button size='small' color='primary' onClick={() => logoPopupState.close()}>{translate(`pos.common.close`)}</Button>
                                            </Box>
                                        </List>
                                    </Paper>
                                </CustomPopover>
                            </CardContent>
                        </Grid>
                    </Grid>
                </Card>

            </Box>
            <Box my={2}>
                <TextField
                    style={{ width: 500 }}
                    variant='filled'
                    label={translate(`pos.support.description`)}
                    error={error.description.status && error.description.messsage !== ''}
                    helperText={error.description.messsage}
                    multiline
                    rows={5}
                    value={textValue.description}
                    onChange={(event) => onChangTextValue(event, 'description')}
                    endDom={<CustomPoper
                        open={openPoper}
                        anchorEl={anchorEl}
                        handleClick={handleClickOpenPoper}
                        handleClose={handleClosePoper}
                        title={translate(`pos.support.description`)}
                        content={translate(`pos.media.descriptionContent`)}
                        icon={<b>?</b>}
                    />} />
            </Box>
            <Box my={2}>
                <SelectBox
                    label={translate(`pos.media.fileType`)}
                    value={<Typography className={classes.TextValue}>{fileType}</Typography>}
                    open={openFileType}
                    handleClick={() => { setOpenFileType(!openFileType) }}
                    required={true}
                >
                    <ListItem className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickFileTypeValue('From file')}>
                        <Typography className={classes.TextValue}>{translate(`pos.channels.fromFile`)}</Typography>
                    </ListItem>
                    <ListItem className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickFileTypeValue('VOD')}>
                        <Typography className={classes.TextValue} >{translate(`pos.dashboard.vod`)}</Typography>
                    </ListItem>

                </SelectBox>
            </Box>
            {
                fileType === 'From file' ?
                    (
                        <Box display='flex'
                            justifyItems='center'
                            pt={1} pb={2} my={1}
                            bgcolor={colors.white['50']}
                            border={1}
                            borderColor={colors.lightBlue['200']}
                            borderRadius='4px' >
                            <Box width={469} m='auto'>
                                <Typography className={classes.title} style={{ marginBottom: 8 }}>{`${translate(`pos.media.addFile`)} *`}</Typography>
                                <Box display='flex' py={1} px={2} bgcolor='white' border={1} borderColor='#c1e5fa' borderRadius={4}>
                                    <Box display='flex' flexGrow={1} alignItems='center'>
                                        <img src={ic_attachment} width={27} height={27} style={{ marginRight: 8 }}></img>
                                        <Typography className={classes.title}>{translate(`pos.media.file`)}</Typography>
                                    </Box>
                                    <Button variant='contained' color='primary' {...bindToggle(filePopupState)}>
                                        {
                                            file ? translate(`pos.channels.change`) : translate(`pos.channels.browse`)
                                        }

                                    </Button>
                                    <CustomPopover
                                        popupState={filePopupState}
                                        zIndex={2}
                                        placement='right-end'

                                    >
                                        <Paper style={{ padding: theme.spacing(1) }}>
                                            <List>
                                                <ListItem>
                                                    <Typography className={classes.typography} style={{ fontWeight: 500, fontFamily: 'UniviaPro-Medium', marginRight: theme.spacing(1) }}>
                                                        {translate(`pos.infochannel.fileFormat`)}
                                                    </Typography>
                                                </ListItem>
                                                <ListItem button>
                                                    <img src={ic_computer} width={19} height={19}></img>
                                                    <Typography className={classes.typography} style={{ cursor: 'pointer', marginLeft: theme.spacing(1) }}>{translate(`pos.infochannel.computer`)}</Typography>
                                                    <input type='file' accept="video/*,audio/*" onChange={fileBrowserOnChange} className={classes.input} />
                                                </ListItem>
                                                <ListItem button onClick={() => {
                                                    filePopupState.close()
                                                    handleOpenFileDialog('media')
                                                }}>
                                                    <img src={ic_folder} width={19} height={19}></img>
                                                    <Typography className={classes.typography} style={{ marginLeft: theme.spacing(1) }}>{translate(`pos.infochannel.fileManager`)}</Typography>

                                                </ListItem>

                                                <Box display='flex' justifyContent='flex-end'>
                                                    <Button size='small' color='primary' onClick={() => filePopupState.close()}>{translate(`pos.common.close`)}</Button>
                                                </Box>
                                            </List>
                                        </Paper>
                                    </CustomPopover>
                                    {/* <DialogChooseFile
                                            withoutPermission={true}
                                            defaultId={openFile.defaultId}
                                            open={openFile.status}setSoundValue'
                                            pickerMode='pickMediaOnly'
                                            handleClose={handleCloseFileDialog}
                                            setChooseValue={openFile.setResponse}
                                        /> */}

                                </Box>
                                {
                                    file && (
                                        <Box display='flex' py={2} boxShadow='0 3px 6px 0 rgba(27, 102, 157, 0.04)' px={2} my={1} bgcolor='white'>
                                            <Box display='flex' flexGrow={1} alignItems='center'>
                                                <Typography style={{ overflow: 'hidden', textOverflow: 'ellipsis', width: 250 }}>{file.name}</Typography>
                                            </Box>
                                            <Box display='flex'>
                                                <Typography>
                                                    {
                                                        file.size / 1024 < 1000 ? (file.size / 1000).toFixed(0) + ' Kb' :
                                                            file.size / 1024 / 1024 < 1000 ? (file.size / 1024 / 1024).toFixed(2) + ' Mb' :
                                                                (file.size / 1024 / 1024 / 1024).toFixed(2) + ' Gb'
                                                    }
                                                </Typography>
                                                <IconButton
                                                    onClick={() => { setFile(null) }}
                                                    style={{ marginLeft: 34, padding: 0, width: 25, height: 25, borderRadius: 10, border: 'solid 2px #e5f1f8', backgroundColor: 'white' }}>
                                                    <img src={ic_delete} width={12.2} height={12.2} ></img>
                                                </IconButton>

                                            </Box>

                                        </Box>
                                    )
                                }


                            </Box>
                        </Box>
                    )
                    :
                    (
                        <Box my={2}>
                            <TextField
                                required
                                style={{ width: 500 }}
                                variant='filled'
                                label={translate(`pos.media.uri`)}
                                value={textValue.uri}
                                error={error.uri.status && error.uri.messsage !== ''}
                                helperText={error.uri.messsage}
                                onBlur={(event) => onChangTextValue(event, 'uri')}
                                onChange={(event) => onChangTextValue(event, 'uri')}
                            />
                        </Box>
                    )
            }


            <Box my={2} display='flex' width='100%' justifyContent='flex-end' alignItems='flex-end'>
                <TextButton style={{ marginRight: '30px' }} component={Link} to={{ pathname: "/media" }} />
                   
                <Button disabled={isError || loading || textValue.description.length > 500} style={{ pading: 8 }} variant='contained' color='primary' onClick={mediaId ? onEdit : onCreate}>
                    {loading ? (
                        <CircularProgress
                            size={15}
                            thickness={2}
                            color='inherit'
                        />
                    ) :
                        mediaId ? translate(`pos.common.save`) : translate(`pos.common.create`)
                    }
                    {/* {mediaId ? translate(`pos.common.save`) : translate(`pos.common.create`)} */}
                </Button>
            </Box>
            <DialogChooseFile
                formats={openFile.format}
                defaultId={openFile.defaultId}
                open={openFile.status}
                pickerMode='pickMediaOnly'
                handleClose={handleClose}
                setChooseValue={openFile.setResponse}
                isPermission={permissions.functionAction.find((value) => value.function === 'File manager (CRUD)' && (value.isRead || value.isUpdate))}
            />
        </Box >
    )


}
export default FormUpdate